import Actions from '@sigma-legacy-libs/essentials/lib/utils/Actions'

import { validateConditionValue } from '@/utils'

import { resolveRuleItemValue, ruleItemMaxTags, ruleTypes } from '@/components/rules/utils'

import render from './render'

export default {
  name: 'RulesItem',

  props: {
    value: null,

    tag: String,

    ruleType: {
      type: String,
      default: ruleTypes.conditions,
      validator: value => {
        return ~Object.values(ruleTypes).indexOf(value)
      }
    },

    readonly: Boolean,
    clearable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    hasValue() {
      switch (this.ruleType) {
        case ruleTypes.actions: return Actions.validateValue(this.value, this.tag)
        case ruleTypes.conditions:
        default: return validateConditionValue(this.tag, this.value)
      }
    },

    maxTags() {
      return ruleItemMaxTags[this.tag]
    },

    $_value() {
      return resolveRuleItemValue(this.ruleType, this.tag, this.value, this.maxTags)
    }
  },

  render
}
